import React from "react";
import { FormControl } from "react-bootstrap";
import { ApiHelper, SchedulePlaylistInterface, PlaylistInterface, ArrayHelper, ScreenInterface, ToastHelper } from "../../helpers";

interface Props {
  screen: ScreenInterface
  scheduleId: number,
  saveCallback: (scheduleId: number) => void,
  pendingCommand: { action: string, parameter: string }
}

export const SchedulePlaylists: React.FC<Props> = props => {

  const [schedulePlaylists, setSchedulePlaylists] = React.useState<SchedulePlaylistInterface[]>(null);
  const [availablePlaylists, setAvailablePlaylists] = React.useState<PlaylistInterface[]>(null);
  const [deleteIds, setDeleteIds] = React.useState<number[]>([]);


  const init = () => { loadData() }

  const loadData = async () => {
    setSchedulePlaylists([])
    //ApiHelper.get("/playlists/available").then(data => setAvailablePlaylists(data));

    ApiHelper.get<PlaylistInterface[]>("/playlists/available")
      .then((data) => {
        const screenShape = (props.screen?.rotation === 90 || props.screen?.rotation === 270) ? "9:16" : "16:9"
        const result: PlaylistInterface[] = []
        data?.forEach(d => {
          if (d.shape === screenShape) result.push(d);
        })
        setAvailablePlaylists(result);
      })
      .catch(err => console.error("Failed to load available playlists:", err));


    if (props.scheduleId > 0) {
      const data = await ApiHelper.get<SchedulePlaylistInterface[]>("/schedulePlaylists/schedule/" + props.scheduleId) || [];
      if (data.length > 0) {
        const playlistIds = ArrayHelper.getIds(data, "playlistId");
        const playlists = await ApiHelper.get<PlaylistInterface[]>("/playlists?ids=" + playlistIds.join(",")) || [];
        for (let sp of data) sp.playlist = ArrayHelper.getOne(playlists, "id", sp.playlistId);
      }
      setSchedulePlaylists(data);
    }
  }

  const handleDelete = (index: number) => {
    const sp = schedulePlaylists[index];

    if (sp.id && deleteIds.indexOf(sp.id) === -1) {
      let deleteIdsCopy: number[] = [...deleteIds];
      deleteIdsCopy.push(sp.id)
      setDeleteIds(deleteIdsCopy);
    }

    let schedulePlaylistsCopy: SchedulePlaylistInterface[] = [...schedulePlaylists];
    schedulePlaylistsCopy.splice(index, 1);
    setSchedulePlaylists(schedulePlaylistsCopy);
  }


  const handleChange = (e: any, index: number) => {
    let schedulePlaylistsCopy: SchedulePlaylistInterface[] = [...schedulePlaylists];
    let sp = schedulePlaylistsCopy[index];

    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "playlist": sp.playlistId = parseInt(val, 0); break;
      case "weight":
        sp.weight = parseInt(val, 0);
        if (isNaN(sp.weight)) sp.weight = 0;
        break;
    }
    setSchedulePlaylists(schedulePlaylistsCopy);
  }

  const getRows = () => {
    const result: React.ReactElement[] = [];
    const options: React.ReactElement[] = [];
    availablePlaylists?.forEach(ap => { options.push(<option key={ap.id} value={ap.id}>{ap.name}</option>) })

    let idx = 0;
    schedulePlaylists?.forEach(sp => {
      const index = idx;
      const changeFunction = (e: any) => { handleChange(e, index); }
      result.push(<tr key={"sp_" + sp.id + "_" + sp.playlistId}>
        <td><FormControl id="playlist" as="select" size="sm" value={sp.playlistId} onChange={changeFunction}>{options}</FormControl></td>
        <td><FormControl id="weight" value={(sp.weight === 0) ? "" : sp.weight} size="sm" onChange={changeFunction} /></td>
        <td className="action-cell">
          <a href="about:blank" className="text-danger" onClick={(e: React.MouseEvent) => { e.preventDefault(); handleDelete(index) }}><i className="fas fa-trash-alt"></i> Delete</a>
        </td>
      </tr>);
      idx++;
    });
    return result;
  }

  const addRow = (e: React.MouseEvent) => {
    e.preventDefault();
    let weight = 100;
    schedulePlaylists.forEach(sp => weight = weight - sp.weight);
    if (weight < 0) weight = 0;
    const data = [...schedulePlaylists];
    const item: SchedulePlaylistInterface = { id: 0, weight: weight, playlistId: 0 };
    if (availablePlaylists?.length > 0) item.playlistId = availablePlaylists[0].id;
    data.push(item)
    setSchedulePlaylists(data);
  }

  const handleSave = (scheduleId: number) => {
    schedulePlaylists.forEach(sp => sp.scheduleId = scheduleId);
    const promises: Promise<any>[] = []
    deleteIds.forEach(id => { promises.push(ApiHelper.delete("/schedulePlaylists/" + id)) });
    if (schedulePlaylists.length > 0) promises.push(ApiHelper.post("/schedulePlaylists", schedulePlaylists));
    Promise.all(promises)
      .then(() => { props.saveCallback(scheduleId) })
      .catch(err => {
        console.error("Failed to save schedule playlists:", err);
        ToastHelper.error("Failed to save schedule playlists");
      });
  }

  const handleParentCommand = () => {
    if (props.pendingCommand) {
      if (props.pendingCommand.action === "save") handleSave(parseInt(props.pendingCommand.parameter, 0))
    }
  }


  React.useEffect(init, [props.scheduleId, props.screen?.rotation]); // eslint-disable-line
  React.useEffect(handleParentCommand, [props.pendingCommand]); // eslint-disable-line

  return (
    <>
      <div className="section">Playlists</div>
      <div className="table-responsive">
        <table className="table table-sm">
          <thead>
            <tr><th>Playlist</th><th>Weight / Percent</th><th>Action</th></tr>
          </thead>
          <tbody>
            {getRows()}
            <tr><td colSpan={3} className="action-cell text-end">
              <a href="about:blank" className="text-success" onClick={addRow}><i className="fas fa-plus"></i> Add</a>
            </td></tr>
          </tbody>
        </table>
      </div>
    </>
  );
};